// extracted by mini-css-extract-plugin
export default {"labelBox":"labelbox_labelBox__0H-3A","text":"labelbox_text__2rI5u","error":"labelbox_error__JIf6m","success":"labelbox_success__rIOOw"};